module.exports = __webpack_public_path__ + "45ac5d3c5d19f594ad1445b2f7d26079.pdf";